
import React from 'react';

import ReactDOM from 'react-dom';
import { Collapse,CollapseItem,Transition } from 'element-react';

 

import KeeVue from '../base/KeeVue.js'
import FeasComponents from './FeasComponents.js'
import FsResizers from './FsResizers.js'
import FeasPage from './FeasPage.js'

import $ from 'jquery';



export default class FsView extends KeeVue {
  constructor(props) {
         super(props);

			this.state =  {
				id: this.getRandString(),
				currentView: '',
				cacheComponentNames: "",
				cacheComponentArray: [],
				maxCacheComponentNum: 10,
				show: false,
				showType: 'custom',
				fsPages: [],
				seq: 1,
				isOpenRightDetail: false, // 控制右侧滑动窗口的开和关
				needCloseRight: false,
				isRightLoaderShow: false,
				parentUrl: '',
				iframeUrl:'',
				viewWidth:'100%',
			};

}
// componentDidUpdate(props, current_state) {

// 	  console.log("fsview:url:"+this.props.url);

// 	  				this.openComponent(this.props.url, this.props.parameters);


// }
componentDidMount(){
			let that = this;
			
			this.registComponent();
			
			
		 
			if(this.props.showVueMode)
			{
				this.createVueApp();
				return ;
			}
		 
			
			if(this.props.debug !== true) {
				//console.log("view :po:"+JSON.stringify(this.props.po));
				this.openComponent(this.props.url, this.props.parameters);
				let that = this;
			}
			
			
			if(this.props.debug!==true)
			{
			this.onEvent("showUrl", function(url, params) {
				alert("showURLLLLLL");
				that.openComponent(url, params);
			});
			if(that.component !== null)
			{
				//this.onEvent("hashchange",this.onHashChange );
			}
			this.onEvent("rightDetail.close", function() {
				that.needCloseRight = true;
				setTimeout(()=> {
					if(that.needCloseRight === true) {
						that.needCloseRight = false;
						that.state.isOpenRightDetail = false;
						that.state.isRightLoaderShow = false;
					}
				}, 30);
			});
			let hash = window.location.hash;
				hash = window.location.hash;
					hash = hash.replace('#', '');
				if(!hash&&window.history.state&&window.history.state.sp)
				{
					hash=window.history.state.sp;
				}
			//this.onHashChange(hash);
			this.onEvent("keeResize",this.changeFrameHeight);
			}
		}
		
		createVueApp=()=>{
			
			let that = this;
			
			 
			if(!this.vueApp)
			{
				this.vueApp = new window.KeeVue({
					el: '#'+this.state.id,
					data: {
						components:this.props.components,
						keePage:this.props.keePage,
						activeComponent:this.state.activeComponent, 
						currentUrl:this.props.url,
						po:this.props.po,
						showBread:this.props.showBread,
						parameters:this.props.parameters,
					},
					components: {},
					mounted: ()=> { 
						
						// this.onEvent("changedComponents",()=>{ });
					},
					render: function(createElement) {
						 
									 	// <fs-view :url="currentUrl" :keep-alive="true" :parameters="parameters" :debug="false" :is-hidden-scroll="isHiddenScroll"></fs-view>
										
						return createElement('fs-view', {
							attrs: {
								"tag": "fscomponents",
								"ref":"fsViewComponent",
								"url":this.currentUrl,
								"po":this.po,
								"show-bread":this.showBread,
								"parameters":this.parameters,
								"debug":false,
								"is-hidden-scroll":false
							},
							'style':{
								'padding':'0'
							},
							'class': {
								'kee-full-div':true 
							},
							on: {
								changed: this.inited, 
											command:this.onCommand
							}
						}, '');
					},
				methods:{
								 
								openVuePage:function(url,param){
									if(this.$refs["fsViewComponent"])
									{
										
									}
									
								},
					showPage:function(components,keePage,activeComponent){
						//alert(this.props.components.length);
						this.components = components;
						this.keePage = keePage;
						this.activeComponent = activeComponent;
						
						// 页面变更，会触发watch事件，然后重新初始化components，触发inited事件
					},
					inited:function(){
									alert("changeed");
								},
								onCommand: (cmdName, item, po, thisForm, parentForm)=> {
									
									//到顶层了
									if(cmdName === "cancel") {
										that.$emit("cancel");
									}
									if(cmdName === "close") {
										that.$emit("close");
									}
									console.log("到顶层react，command:::"+cmdName);
									that.$emit("command", cmdName, item, po, thisForm, parentForm);
									 
								}
				}});
							
			}
			
			
		}
		
		openVueComponent=(url, activeParams)=>{
			
			console.log("openVueComponent::"+url);
			
			if(this.vueApp&&this.vueApp.$children[0])
			{
				this.vueApp.po = this.po;
				
				this.vueApp.$children[0].openComponent(url,activeParams);
			}
				
			// this.vueApp.openVuePage(url,activeParams);
		}

		onError=()=>{
			this.sendPageEvent("error");
		}
		changeFrameHeight=()=>{
			 let ifm= document.getElementById("iframe"+this.state.id);
			 if(ifm)
			 {
			 }
		}
		onHashChange=(hash)=> { }
			openUrl=(url)=> {
				this.openComponent(url, this.props.parameters);
			}
			
			showPage=(url,param)=> {
				this.showPageMode= true;
				this.openComponent(url, param);
			}
			
			onChanged=(ret)=> {
				this.$emit("changed", ret);
			}
			cancel=(ret)=> {
				this.$emit("cancel", ret);
			}
			onCommand=(cmdName, item, po, thisForm, parentForm)=> {
				if(cmdName === "cancel") {
					this.$emit("cancel");
				}
				if(cmdName === "close") {
					this.$emit("close");
				}
				this.$emit("command", cmdName, item, po, thisForm, parentForm);
			}
			showWindow=(args)=> { alert("已取消该功能")}
			openDialog=(config)=> { 
				alert("已取消该功能")
			}
			
			clear=()=>{
				this.state.fsPages=[];
				this.refresh();
			}
			
			setViewWidth=(config)=>{
				
				this.state.viewWidth= "100%";
						
							if(!config)
							{
								return ;
							}
							let width=null;
							
							let windowWidth = window.innerWidth;
							let windowHeight = window.innerHeight;
							let top = windowHeight * 0.15;
							let left = 0;
							
							if( config.size == "s0") {
								width = 500;
							}
							if(config.size == "s1"||config.size == "normal") {
								width = 800;
							}
							if(config.size == "s2") {
							  width = windowWidth * 0.6;
								if(width < 900)
									width = 900;
								if(width > 1200)
									width = 1200;
							}
							if(config.size == "s3") {
								  width = windowWidth * 0.8;
				
								if(width > 1400)
									width = 1400;
							} 
							
							if(!isNaN( config.size ))
							{
								width = config.size;
							}
							
							if(width)
							{
								this.state.viewWidth = width+"px";
							}
							
							//debugger;
						
						}
			openComponent=(url, activeParams, type)=> {
				let state = this.state;
				let that = this;
				
				if(! url ) {
					return;
				}
				
				if(url=='dev')
				{
					return ;
				}
				
				console.log("FsView:开：" + url + "   id:" + state.id);
				
				this.setViewWidth(activeParams);
				
				this.url=url;
				this.fromItem = this.props.fromItem;
				state.currentView = '';
				
				if(url.indexOf("http://")===0 || url.indexOf("https://")===0) {
					state.showType = "iframe";
					if(window.location.href.indexOf("https://")===0)
					{
						url = url.replace("http://","https://");
					}
					state.iframeUrl=url;
					return;
				}
				if(url.startsWith("/vm/")) {
					url = window.rootUri + url;
				}

				this.needCloseRight = false;
				setTimeout(function() {
					state.isRightLoaderShow = true;
				}, 50);
				if(url.indexOf("/demo") !== -1 || url.indexOf("M::") !== -1) {
					let shortUrl = url;
					// if(shortUrl.indexOf("&") !== -1) {
					// 	shortUrl = shortUrl.substring(0, shortUrl.indexOf("&"));
					// }
					state.showType = "demo";
					let name = "";
					if(shortUrl.indexOf("code=") !== -1) {
						name = shortUrl.substring(shortUrl.indexOf("code=") + 5)
					} else {
						if(shortUrl.indexOf("pid=") !== -1) {
							name = shortUrl.substring(shortUrl.indexOf("pid=") + 4)
						}
					}
					if(shortUrl.indexOf("M::") !== -1) {
						name = shortUrl.replace("M::", "");
					}

					name=name+"&appCode="+this.props.appCode;
					console.log("name:"+name);

					state.seq++;
					let exists = false;
					for(let i = 0; i < state.fsPages.length; i++) {
						if(state.fsPages[i].name === name) {
							exists = true;
							state.fsPages[i].seq = state.seq;
							state.fsPages[i].active = true;
						} else {
							state.fsPages[i].active = false;
						}
					}
					if(state.fsPages.length >= 10) {
						let minSeq = 0;
						let toDelPage = null;
						for(let i = 0; i < state.fsPages.length; i++) {
							if(state.fsPages[i].seq < minSeq || minSeq === 0) {
								minSeq = state.fsPages[i].seq;
								toDelPage = state.fsPages[i];
							}
						}
						if(toDelPage !== null) {
							state.fsPages.remove(toDelPage);
						}
					}
					if(!exists) {
						console.log("fs-view:开：不存在，需要添加")
						let pageObject = {
							id: this.getRandString(),
							name: name,
							active: true,
							seq: state.seq,
							type: type,
							config: activeParams,
							appCode:that.props.appCode,
						}
						state.fsPages.push(pageObject);
						
						// setTimeout(()=> {
						// 	if(pageObject&&pageObject.feasPage)
						// 	{
						// 		pageObject.feasPage.$emit("active", activeParams);
						// 	}
							
							
							 
						// }, 200);
						
					} else {
						for(let i = 0;  i < state.fsPages.length; i++) {
							if( state.fsPages[i].name === name) {
								 state.fsPages[i].feasPage.$emit("active", activeParams);
							}
						}

					}
					this.setState(state);
					return;
				} else {
					state.showType = "customJsp";
				}
				let modelName = "c" + encodeURIComponent(url).replace(/%/g, "").replace(/\./g, "");
				if(url.indexOf("?") !== -1) {
					url += "&keeComponentName=" + modelName;
				} else {
					url += "?keeComponentName=" + modelName;
				}
				state.cacheComponentArray.remove(modelName);
				state.cacheComponentArray.push(modelName);
				for(let n = 0; state.cacheComponentArray.length > state.maxCacheComponentNum; n++) {
					state.cacheComponentArray.splice(0, 1);
				}
				let names = "";
				for(let n = 0; n < state.cacheComponentArray.length; n++) {
					if(names !== "") {
						names += ","
					}
					names += state.cacheComponentArray[n];
				}
				state.cacheComponentNames = names;
				// if(window.KeeComponents[modelName] !== null) {
				// 	state.currentView = window.KeeComponents[modelName];
				// 	setTimeout(()=> {
				// 		if(that.keePageCode !== null) {
				// 			this.$emit(that.keePageCode + ".active", activeParams);
				// 		} else {
				// 			that.$emit(modelName + ".active", activeParams);
				// 			that.refs["dongtaiComonent"].$emit("active", activeParams);
				// 		}
				// 	}, 200);
				// } else {
				// 	window.dongTaiPage = null;
				// 	window.PAGE = null;
				// 	window.keeLoadFile( );
				// }

				this.setState(state);

			}
			close=()=> {
				this.$emit("close");
			}


shouldComponentUpdate(nextProps, nextState) {
	
		// for(let p in this.props)
		// {
		// 	if(this.props[p]!=nextProps[p])
		// 	{
		// 		console.log(p,JSON.stringify(this.props[p]));
		// 		console.log(p,JSON.stringify(nextProps[p]));
				
		// 		return true;
		// 	}
		// }
		
		// for(let p in this.state)
		// {
		// 	if(this.state[p]!= nextState[p])
		// 	{
		// 		return true;
		// 	}
		// }
		
		//alert("this.url="+this.url+"-next:"+nextProps.url);
		// if(!this.url||this.url!=nextProps.url )
		// {
		// 	this.url =nextProps.url;
		// 	 return true;
		// }
		// else
		// {
		// 	//alert("falsessss")
		// 	return false;
		// }
		 
		
		if(nextProps.isMouseMove)
		{
			return false;
		}
		return true;
	}
	
	 

			componentWillReceiveProps(nextProps){
							//   console.log("触发更新FsView：url:"+nextProps.url)
							// //  console.log(JSON.stringify(nextProps.po));
							
							// 	console.log("FsView加载url："+this.fromItem+"  "+this.props.fromItem);
							   
							//    console.log("FsView加载url:this.url:"+this.url);
							//    console.log("FsView加载url:nextProps.url:"+nextProps.url);
							//    console.log("FsView加载parameters:"+(JSON.stringify(this.props.parameters)==JSON.stringify(nextProps.parameters)));
							    
							 //   console.log("FsView加载url22222："+nextProps.url);
							   
							  let that = this;
							  if(nextProps.url)
							  {
								  
								   
									  if(this.fromItem!=this.props.fromItem||this.po!= nextProps.po||this.keePage!= nextProps.keePage||this.url!=nextProps.url||JSON.stringify(this.props.parameters)!=JSON.stringify(nextProps.parameters))
									  {
										  console.log("FsView加载url22："+nextProps.url);
										  //
										   this.po = nextProps.po;
										  if(this.props.showVueMode)
										  {
											  if(nextProps.parameters)
											  {
												  that.openVueComponent(nextProps.url,nextProps.parameters);
											  }
											  else
											  {
												  that.openVueComponent(nextProps.url,{po:this.po});
											  } 
										  }
										  else
										  {
											  that.openComponent(nextProps.url,nextProps.parameters);
										  }
										  
										 
										 
										  this.url=nextProps.url;
										  this.fromItem = this.props.fromItem;
										  this.keePage = this.props.keePage;
									  }
								   
							  }
							    




			}
			
			getShowPage=()=>{
				return window.CReactMap[  this.props.component.id+this.props.component.alias];
			}


  render(){
	 // console.log("重新渲染fsView   "+this.showPageMode)
	 
	if(this.props.showVueMode)
	 {
		return <div id={this.state.id}></div>
	 }
	  
	  if(this.showPageMode)
	  {
		  return <div>
			{
				this.state.fsPages.map((item,index)=>{
					
					 console.log("重新渲染fsView"+item.name);
					return <div key={item.id+index}   style={{display:(this.state.showType==='demo'&&item.active===true?'block':'none'),width:' 100%',height:' 100%',padding:' 0px'}} >
			  
				{
			
					<FeasPage  
					 ref={(rel) => {item.feasPage = rel;}}
					 name={item.name} nameB={item.name}
					 
					 viewName={this.props.component?this.props.component.id+this.props.component.alias:''}
					  
					appCode={item.appCode} parentView={this.props.component?this.props.component.alias:''}
					owner={this.props.owner} parameters={item.config}
					po={this.props.po}
					minWidth={this.props.minWidth}
					onChanged={this.onChanged}
					onCommand={this.onCommand}
					onError={this.onError}
					debug={this.props.debug}>
					</FeasPage>
			
				}
				 
			
			</div>
				})
			}
		  </div>
	  }
	  
	  // 'width':this.state.viewWidth 
	  
  return(

<div fs-view="fs-view"  className={`kee-fs-view-main`} style={{'width':'100%','height':(this.props.isHiddenScroll!==false||(this.props.component&&this.props.component.cp.fullHeight)||(!window.isPub)?'100%':'auto'),'minHeight':((this.props.debug?'100px':'300px')),'background':(this.props.debug===true?'#aaaaaa':'')}} >


   {
		this.state.showType=='iframe'&& <div style={{width:' 100%', height:'100%',  overflow:' auto', padding:' 0px'}}>
			<iframe className={`kee-fs-view-iframe`} id={'iframe'+this.state.id} src={this.state.iframeUrl} style={{'min-height':(this.props.component&&this.props.component.cp.minHeight&&this.props.component.cp.minHeight!==''?this.props.component.cp.minHeight:'600px')}} onload={this.changeFrameHeight} >
			</iframe>
		</div>
	}

    {
		this.state.fsPages.map((item,index)=>{
			
			// console.log("重新渲染fsView  "+item.name);
			return <div key={item.id+index}   style={{display:(this.state.showType==='demo'&&item.active===true?'block':'none'),width:' 100%',height:(this.props.isHiddenScroll!==false||(this.props.component&&this.props.component.cp.fullHeight)||(!window.isPub)?'100%':'auto'),padding:' 0px'}} >
      
		{

			<FeasPage  
			 ref={(rel) => {item.feasPage = rel;}}
			 name={item.name} nameB={item.name}
			  viewName={this.props.component?this.props.component.id+this.props.component.alias:''}
			appCode={item.appCode} parentView={this.props.component?this.props.component.alias:''}
			owner={this.props.owner} 
			parameters={item.config}
			po={this.props.po}
			minWidth={this.props.minWidth}
			onChanged={this.onChanged}
			onCommand={this.onCommand}
			onError={this.onError}
			debug={this.props.debug}>
			</FeasPage>

		}
		{
			item.type=='detail'&&
			<Transition name="rightmove" >
			    <div className={`feas-right-detail-div`} v-show="isRightLoaderShow===true" style={{borderLeft:'1px solid #ddd'}} >
			        <FeasPage ref={(rel) => {item.feasPage = rel;}}  
					minWidth={this.props.minWidth}
					name={item.name} 
					appCode={this.props.appCode} 
					parentView={this.props.component?this.component.alias:''} owner={this.props.owner} 
					parameters={item.config} po={this.props.po} onclose={this.state.isRightLoaderShow=false} 
					onChanged={this.onChanged} onCommand={this.onCommand} onerror={this.onError} >
			        </FeasPage>
			    </div>
			</Transition>
		}
		{
			/*item.type=='dialog'&&!item.config.feasName&&item.active===true&&
			<FsDialog   config={item.config} ref={ 'pages'} feas-name={item.config.feasName} fsName={item.config.fsName} url={item.config.url} configUrl={item.config.configUrl} extraParas={item.config.extraParas} dialog-title={item.config.dialogTitle} defaultEntity-id={item.config.defaultEntityId} size={item.config.size} alias={item.config.alias} >
			</FsDialog>*/
		}

    </div>
		})
	}

</div>
  );}
 }

